import React from 'react';
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import ClinicPatientSlot from './Dashboard Widgets/ClinicPatientSlot';
import HorizontalBarCharts from './Dashboard Widgets/HorizontalBarCharts';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// Example Data & Options for Highcharts Line Chart
const lineOptions = {
  chart: {
    type: 'line',
    backgroundColor: '#fff',
    borderRadius: 12,
  },
  title: { text: 'Patients Trend' },
  xAxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] },
  yAxis: { title: { text: 'Patients' } },
  series: [{ name: 'Patients', data: [22, 28, 32, 40, 36, 38] }],
  credits: { enabled: false },
};

// Example Data & Options for Highcharts Pie Chart
const pieOptions = {
  chart: {
    type: 'pie',
    backgroundColor: '#fff',
    borderRadius: 12,
  },
  title: { text: 'Appointment Types Distribution' },
  series: [
    {
      name: 'Appointments',
      data: [
        { name: 'General', y: 24 },
        { name: 'Follow-up', y: 12 },
        { name: 'Emergency', y: 5 },
      ],
      colorByPoint: true,
    }
  ],
  credits: { enabled: false },
};

// ✅ Cards data
const cardsData = [
  {
    title: "Total Clinics",
    count: 29,
    icon: "fa-users",
    bgColor: "#8e9eceff", // Blue
  },
  {
    title: "Total Subscriptions",
    count: 18,
    icon: "fa-check-to-slot",
    bgColor: "#68c7a4ff", // Green
  },
  {
    title: "Revenue Overview",
    count: "$12K",
    icon: "fa-file-invoice-dollar",
    bgColor: "#37c5beff", // Yellow
  },
  {
    title: "Total Modules",
    count: 7,
    icon: "fa-calendar-days",
    bgColor: "#f7bb6dff", // Red
  },
];

function Dashboard() {
  const navigate = useNavigate();
  const dashboardstyles=`
  .card-hover {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.card-hover:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
`

  return (
    <>
    <style>{dashboardstyles}</style>
      <div id='main-dashboard'>
        <div className="row">
          <div className="col-12 mb-3 mt-3">
            <h3 className="">Dashboard</h3>
          </div>
        </div>

        <div className="row">
          {cardsData.map((card, index) => (
            <div
              key={index}
              className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-3"
            >
              <div
                className="p-3 rounded shadow-md text-white d-flex flex-column justify-content-between card-hover"
                style={{ background: card.bgColor, borderRadius: "12px", minHeight: "120px" }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="p-2 rounded-circle bg-white"
                      style={{ width: "2.5rem", height: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                      <i className={`fa-solid ${card.icon} fa-lg`} style={{ color: card.bgColor }}></i>
                    </div>
                    <p className="m-0 fw-semibold">{card.title}</p>
                  </div>
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <h2 className="fw-bold">{card.count}</h2>
              </div>
            </div>
          ))}
        </div>

        {/* --- New graphs using Highcharts --- */}
        <div className="row mt-4">
          <div className="col-12 col-lg-6 mb-4">
            <HighchartsReact highcharts={Highcharts} options={lineOptions} />
          </div>
          <div className="col-12 col-lg-6 mb-4">
            <HighchartsReact highcharts={Highcharts} options={pieOptions} />
          </div>
        </div>

        {/* --- Keep other components/graphs unchanged --- */}
        <div className="row">
          <div className="col-12 col-lg-6 mb-4 mt-3">
            <HorizontalBarCharts />
          </div>

          <div className="col-12 col-lg-6 mb-4 mt-4">
            <div
              className="p-3"
              style={{
                boxShadow:
                  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                borderRadius: "12px",
              }}
            >
              <span className="fw-bold">Patient Management</span>
              <div className="d-flex align-items-center gap-2 mt-2 mb-3">
                <img src="/Images/clock_tick.png" alt="" style={{ width: "16px" }} />
                <span>12:30 </span>
                <img src="/Images/right_arrow.png" alt="" />
                <span> 2:30</span>
              </div>
              <div className="w-100">
                <ClinicPatientSlot />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
